export const isMacOs = () => {
  if (navigator.userAgentData) {
    return navigator.userAgentData.platform === 'macOS';
  } else {
    // Fallback for older browsers
    return navigator.platform.indexOf('Mac') !== -1;
  }
}
